import resultMany from '../resultMany';

export default (item = {}, paths = [], defaultValue) => ({
    ...item,
    [paths[0]]: resultMany(item, ...paths) || defaultValue,
});
